export default "__VITE_ASSET__DmQfp9Up__"